import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function Slidertwo() {
  const data = [
    {
      id: 1,
      img: "assets/images/sponsors/sponsor-3-1.png",
    },
    {
      id: 2,
      img: "assets/images/sponsors/sponsor-3-2.png",
    },
    {
      id: 3,
      img: "assets/images/sponsors/sponsor-3-3.png",
    },
    {
      id: 4,
      img: "assets/images/sponsors/sponsor-3-4.png",
    },
    {
      id: 5,
      img: "assets/images/sponsors/sponsor-3-5.png",
    },
    {
      id: 6,
      img: "assets/images/sponsors/sponsor-3-6.png",
    },
    {
      id: 7,
      img: "assets/images/sponsors/sponsor-3-1.png",
    },
    {
      id: 8,
      img: "assets/images/sponsors/sponsor-3-2.png",
    },
  ];

  return (
    <section className="sponsor-three">
      <div className="container">
        <Swiper
          loop={true}
          spaceBetween={30}
          slidesPerView={2}
          breakpoints={{
            576: {
              slidesPerView: 3,
            },
            992: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 6,
            },
          }}
        >
          {data.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="sponsor-one__item">
                <img src={item.img} alt={`Sponsor ${item.id}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default Slidertwo;
